// extracted by mini-css-extract-plugin
export default {"logo":"Cabecalho_logo__GM019","App-logo-spin":"Cabecalho_App-logo-spin__ExjOx"};